import { ChangeDetectionStrategy, Component, inject, input, model } from '@angular/core';
import { DateService, Nullable } from '@softline/core';
import { DateRangePickerComponent } from '../../date-range-picker/date-range-picker.component';
import { ResolvableModal } from '@softline/ui-core';
import { DateRange } from '@softline/ui-core';
import { FormatPipe } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
import { DateRangePickerSelectionMode } from '../../date-range-picker/date-range-picker.types';

@Component({
  selector: 'soft-date-range-input-dialog',
  templateUrl: './date-range-picker-modal.component.html',
  styleUrls: ['./date-range-picker-modal.component.css'],
  imports: [TranslatePipe, DateRangePickerComponent, FormatPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangePickerModalComponent extends ResolvableModal<DateRange | null> {
  readonly dateService = inject(DateService);
  readonly today = {from: this.dateService.now(), to: this.dateService.now()};

  readonly title = input<string | null>();
  readonly subtitle = input<string | null>();
  readonly value = model<DateRange | null>(null);
  readonly shortcuts = input<{ value: DateRange; label: string }[] | null>(null);
  readonly startField = input<'from' | 'to'>('from');
  readonly selectionMode = input<DateRangePickerSelectionMode>('range');
  readonly firstSelectDay = input<number>(1);
  readonly selectSize = input<number>();

  onValueChange(value: Nullable<DateRange> | null): void {
    if (value && value.from && value.to) {
      this.resolve({from: value.from, to: value.to});
    }
  }
}
